import { Box, Dialog, DialogContent, DialogTitle, Drawer, Hidden } from "@mui/material";
import * as React from "react";
import { useStyles } from "./styles";
export const DialogDrawer = (props) => {
    const classes = useStyles(props);
    return (
        <div>
            <Hidden smDown>
                <Dialog
                    open={props?.open}
                    onClose={props?.onClose}
                    aria-labelledby="alert-dialog-title"
                    className={classes.dialog}
                    maxWidth={props?.maxWidth ? props?.maxWidth : props?.width ?? "xs"}
                    fullWidth
                    aria-describedby="alert-dialog-description"
                >
                    {
                        !props?.isnotTitle &&
                        <DialogTitle className={classes.header} textTransform={props?.header_text_transform}>
                            <span>{props?.header}</span>{" "}
                            <img
                                src="/images/close.svg"
                                alt="close"
                                onClick={props?.onClose}
                                style={{ cursor: 'pointer' }}
                            />
                        </DialogTitle>
                    }

                    <DialogContent style={{ padding: "0 !important" }}>
                        <Box height={props?.height ?? "auto"} overflow={props?.overflow ?? "auto"} padding={props?.padding ?? 2} className={classes.component}>
                            {props?.component ?? props?.dialogComponent}
                        </Box>
                    </DialogContent>
                </Dialog>
            </Hidden>
            <Hidden smUp>
                <Drawer
                    anchor="bottom"
                    className={classes.drawer}
                    open={props?.open}
                    onClose={props?.onClose}
                >
                    {
                        !props?.isnotTitle &&
                        <DialogTitle className={classes.header} textTransform={props?.header_text_transform}>
                            <span>{props?.header}</span>{" "}
                            <img
                                src="/images/close.svg"
                                alt="close"
                                onClick={props?.onClose}
                                style={{ cursor: 'pointer' }}
                            />
                        </DialogTitle>
                    }

                    <Box height={props?.height ?? "auto"} overflow="auto" padding={props?.padding ?? 2} className={classes.component}>
                        {props?.component ?? props?.drawerComponent}
                    </Box>
                </Drawer>
            </Hidden>
        </div>
    );
}
